module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA8CAYAAADWibxkAAAA7ElEQVRoQ+3YMQ7CMBBE0bjkdmm5DbdJm9tBB6JDaVZGdgaJl9aSNxntzB+lLeFn3e63ka+wXy9d97WRw7+5iwA2gAW6PFvZTAYIQRToshQMVqEy+1wP0AP0gK7QqiypB+gBekCXpfSAKlRmn+sBesCf94DZFqvuj4dg9YKzzwkwW+Ffv7+NxtDxg3u7+dmCEcAGDC4iLHBQoMqAdXs8z/b957x4BhDABrCADBCCQQVQIN0EYRAGYRAGgxBYUAAFwv8DYBAGYRAGoxhMDn/PjocgAcIK2IA0BsMLIANYgAXCTVAGhBWQATIgmwEvflkODGt1PVoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tit.png
// module id = 48
// module chunks = 1